// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selected-carousel{height:100%;margin-left:5em;position:relative;outline:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;font-size:.775em}.selected-carousel__slide{height:100%;display:inline-block;width:20%;position:absolute;transition:0.3s ease;padding:0}\n", ""]);
// Exports
module.exports = exports;
